module.exports = __webpack_public_path__ + "static/img/dynamicb.a2c9681.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicb.png
// module id = TN33
// module chunks = 45